import { render } from "./popup.vue?vue&type=template&id=629e6a5c"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"

import "./popup.vue?vue&type=style&index=0&id=629e6a5c&lang=scss"

import exportComponent from "D:\\Development\\vue\\okraina.sbs.monitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__